import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/69970b01f782d50014979e7f_1791115115949_8739b572/cateringhub/src/app/not-found.tsx");
